<template>
  <div class="page-body">
    <pageMobileHeader @onClick="handlerClick" v-if="isMobile"></pageMobileHeader>
    <pageHeader v-else></pageHeader>
    <div class="empty-header" v-if="isMobile"></div>
    <div class="page-container">
      <slot></slot>
    </div>
    <pageMobileFooter v-if="isMobile"></pageMobileFooter>
    <pageFooter v-else></pageFooter>
    <div class="panel">
      <div class="panel-top tr"> <i class="close-icon" @click="handlerClick"></i></div>
      <div class="inner">
     <ul class="nav-list">
        <router-link
           tag="li"
           class="item dib"
           :class="pageName === nav.path ? 'is-active' :''"
           v-for="nav in navList"
           :to="nav.path"
           :key="nav.path"
            rel="noopener">
          {{nav.name}}
        </router-link>
      </ul>
      </div>
    </div>
  </div>
</template>
<script>
import pageHeader from './pageHeader'
import pageMobileHeader from './mobileHeader'
import pageMobileFooter from './mobileFooter'
import pageFooter from './pageFooter'
import { hasClass, addClass, removeClass } from '@/utils/dom'
export default {
  name: 'layout',
  components: {
    pageHeader,
    pageMobileHeader,
    pageMobileFooter,
    pageFooter
  },
  computed: {
    isMobile () {
      const info = navigator.userAgent
      const agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPod', 'iPad']
      for (let i = 0; i < agents.length; i++) {
        if (info.indexOf(agents[i]) >= 0) {
          return true
        };
      }
      return false
    },
    pageName ({ $route: { name } }) {
      return name
    }
  },
  data () {
    return {
      navList: [
        {
          path: 'home',
          name: '首页'
        },
        {
          path: 'product',
          name: '产品介绍'
        },
        {
          path: 'cooperation',
          name: '合作案例'
        },
        {
          path: 'about',
          name: '关于我们'
        }
      ]
    }
  },
  methods: {
    handlerClick () {
      const panel = document.querySelector('.panel')
      if (hasClass(panel, 'animate-moveToRight')) {
        removeClass(panel, 'animate-moveToRight')
      } else {
        addClass(panel, 'animate-moveToRight')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.page-body {
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
  perspective: 1200px;
}
.empty-header {
  height: 2rem;
}
.page-container {
  flex: 1;
}
.panel {
    width: 50%;
    height: 100%;
    position: absolute;
    top: 2rem;
    left: -50%;
    color: #fff;
    background-color: #000;
    visibility: hidden;
    overflow: hidden;
    backface-visibility: hidden;
    transform: translate3d(0, 0, 0);
    transform-style: preserve-3d;
  .close-icon {
    display: inline-block;
    height: 20px;
    width: 20px;
    background-image: url("data:image/svg+xml,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='64' height='64'%3E%3Cpath d='M519.02 459.48L221.894 162.354a37.079 37.079 0 1 0-52.453 52.405l297.124 297.15-297.124 297.15a37.079 37.079 0 1 0 52.43 52.429l297.15-297.125 297.15 297.125a37.079 37.079 0 1 0 52.428-52.405L571.475 511.91l297.124-297.125a37.079 37.079 0 1 0-52.429-52.43L519.045 459.48z' fill='%23fff'/%3E%3C/svg%3E");
    background-size: contain;
    background-repeat: no-repeat;
    border: 10px solid transparent;
  }
  .nav-list {
    li {
      font-size: 16px;
      padding: 0 20px;
      line-height: 45px;
      display: block;
    }
  }
}
.animate-moveToRight {
    -webkit-animation: moveToRight .6s ease both;
    -moz-animation: moveToRight .6s ease both;
    animation: moveToRight .6s ease both;
    visibility: visible;
    z-index: 1;
}

@keyframes moveFromLeft {
from { transform: translateX(-100%); }
}

@keyframes moveToRight {
to { transform: translateX(100%);}
}
</style>
